import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {guideClosetModalPointsType} from "./__graphql-types__/index.ts";

export const POINTS_QUERY: GqlOperation<
    guideClosetModalPointsType["response"],
    guideClosetModalPointsType["variables"]
> = gqlOp(gql`
    query guideClosetModalPoints {
        user {
            id
            points
        }
    }
`);
